<div
    class="card mb-3 shadow-sm no-select"
    [class.card-disabled]="!profile.active"
    [class.card-active]="isActive"
    (click)="toggleActive(profile.userId)"
>
    <div class="card-body py-2">
        <div class="row no-gutters align-items-center">
            <div class="col-auto mr-3 underline" [routerLink]="['../profile', profile.userId]">
                <app-user-avatar [firstName]="profile.firstName" [lastName]="profile.lastName" [picture]="profile.pictureReference">
                </app-user-avatar>
            </div>

            <div class="col">
                <div>
                    <p *ngIf="isAdminProfile; else userProfileLink" class="mb-0 font-weight-bold">
                        <span [routerLink]="['../profile', profile.userId]" class="underline"> {{ profile.firstName }} {{ profile.lastName }}</span>
                    </p>
                    <ng-template #userProfileLink>
                        <p class="mb-0 font-weight-bold">
                            <span [routerLink]="['../profile', profile.userId]" class="underline">
                                {{ profile.firstName }} {{ profile.lastName }}</span
                            >
                        </p>
                    </ng-template>

                    <p class="text-muted small mb-1" *ngIf="profile.jobTitle">
                        {{ profile.jobTitle.length > 30 ? (profile.jobTitle | slice : 0 : 28) + '...' : profile.jobTitle }}
                    </p>
                </div>
            </div>
        </div>
        <div>
            <div class="d-flex align-items-center mb-1" *ngIf="profile.organization?.name">
                <em class="icon icon-organization mr-2"></em>
                <span class="text-link underline" [routerLink]="['/organizations/', profile.organization?.id]">
                    {{ profile.organization.name }}
                </span>
            </div>

            <div class="d-flex align-items-center" *ngIf="profile.organization.city">
                <em class="icon icon-marker mr-2"></em>
                <span>
                    {{ profile.organization.city }}
                </span>
            </div>
        </div>
    </div>
</div>
